import axios from "axios";
import BASE_URL from "./index";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

export const getAllEventOptions = async (data) => {
  try {
    const res = await axios.get(BASE_URL + "/eventOptions/getAll", {
      Headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data[0];
  } catch (error) {}
};

// Errors are not swallowed: this used to catch and discard every failure, so
// a rejected save looked exactly like a successful one to the screen.
export const updateAllEventOptions = async (data) => {
  return axios.post(BASE_URL + "/eventOptions/updateAll", { data });
};
